import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './EmployeetypeList.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const EmployeetypeList = () => {
  const [employeetype, setEmployeetype] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployeetype = async () => {
      try {
        const response = await axios.get(`${url}/api/employeetype`);
        setEmployeetype(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch Employeetype');
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeetype();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${url}/api/employeetype/${id}`);
      setEmployeetype(employeetype.filter(employeetype => employeetype._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete Employeetype');
    }
  };

  if (loading) return <div className="loading">Loading Employeetype...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="countries-container">
      <div className="header">
        <h2>Employeetype List</h2>
        <button 
          onClick={() => navigate('/AddEmployeetype')}
          className="add-button"
        >
          <Plus size={16} /> Add Employee Type
        </button>
      </div>

      <table className="countries-table">
        <thead>
          <tr>
            <th>Employee Type</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {employeetype.map(employeetype => (
            <tr key={employeetype._id}>
              <td>{employeetype.name}</td>
              <td className="actions">
                <button 
                  onClick={() => navigate(`/employeetype/edit/${employeetype._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                {/* <button 
                  onClick={() => handleDelete(employeetype._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EmployeetypeList;